import request from './../../http/axios';

const apiAgent = '/api/admin';
const portalAgent = '/portal/admin';

const getDic = (data) => {
  return request({
    url: apiAgent + '/dict/type/' + data,
    method: 'get'
  })
}

const getMap = (code,data) => {
  return request({
    url: portalAgent + '/report/unify/query/' + code,
    method: 'get',
    params: data
  })
}

const getMapDownload = (code,data) => {
  return request({
    url: portalAgent + '/report/unify/download/' + code,
    method: 'get',
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json'
    },
    params: data
  })
}

const getEnterpriseDetailData = (data) => {
  return request({
    url: apiAgent + '/enterpriseData/detail',
    method: 'post',
    data
  })
}


// 拉取启信宝数据并评分
const getEnterpriseData = (data) => {
  return request({
    url: apiAgent + '/enterpriseData/handle',
    method: 'post',
    data
  })
}

export {
  getDic,
  getMap,
  getEnterpriseData,
  getEnterpriseDetailData,
  getMapDownload
}


// WEBPACK FOOTER //
// ./src/plugins/api/public/public.js